<div class="modal-dialog" [attr.role]="'document'">
	<div class="modal-content">
		<p class="col-sm-2 col-sm-offset-10 generic-close-modal-btn">
			<button class="btn btn-default-reverse btn-block btn-sm"
				data-dismiss="modal" type="button">Chiudi</button>
		</p>
		<div *ngIf="fondoRischiRevisioniList.length > 0" class="modal-dialog"
			role="document">
			<div class="col-sm-12 coldx">
				<h4>Revisioni del fondo rischi</h4>
				<ul
					*ngFor="let fondoRischiRevisione of fondoRischiRevisioniList let i=index"
					id="controparticollapse" class="controparti">
	
					<li class="panel open_lighter">
						<div class="controparte">
							<div>
								<a data-toggle="collapse" href="#subcontroparti{{i}}"
									aria-expanded="false" aria-controls="'subcontroparti'+i"
									class="collapsed"><span>Apri</span></a>
								<h4 class="titolo col-sm-4">
									<a data-toggle="collapse" href="#subcontroparti{{i}}"
										aria-expanded="false" aria-controls="'subcontroparti'+i"
										class="collapsed"> Data inizio validit&agrave; {{
										fondoRischiRevisione.dataRevisioneDa | date:'dd/MM/yyyy'}}</a>
								</h4>
								<ng-template [ngIf]="!fondoRischiRevisione.gradoRischio">
									<p class="col-sm-4 matricola">
										Fondo rischi non attivo
									</p>
								</ng-template>
								<ng-template [ngIf]="fondoRischiRevisione.gradoRischio">
									<p class="col-sm-4 matricola">
										Grado di rischio: <strong>{{
											fondoRischiRevisione.gradoRischio?.label}}</strong>
									</p>
								</ng-template>
				  <p class="col-sm-4 matricola" *ngIf="fondoRischiRevisione.fondorischiControparti.length > 0 && !fondoRischiRevisione.importiTotali">
					Totale
					<strong>{{calcolaSomma([sommaFondoRischiControparteAttr(fondoRischiRevisione,'sorte'),
							sommaFondoRischiControparteAttr(fondoRischiRevisione,'speseGiudizio'),
							sommaFondoRischiControparteAttr(fondoRischiRevisione,'interessi')
						]
					)
					  }} &euro;</strong>
				  </p>
				  <p class="col-sm-4 matricola" *ngIf="fondoRischiRevisione.fondorischiControparti.length === 0 && (fondoRischiRevisione.importiTotali || fondoRischiRevisione.percentualeSoccombenza) ">
					Totale
					<strong>{{calcolaSomma([fondoRischiRevisione.importoFR, fondoRischiRevisione.interesseFR, fondoRischiRevisione.speseFR])}} &euro;</strong>
				  </p>
							</div>
						</div>
						<ul class="subcontroparte collapse" id="subcontroparti{{i}}"
							aria-expanded="false" style="height: 40px;">
							<li>
								<div class="row_container_fieldset mtop20">
									<fieldset class="form-group">
										<legend>Revisione del fondo rischi</legend>
										<div class="row">
											<div class="bloccodati col-sm-12">
												<p class="col-sm-4">
													<label for="imp-fndrsc-rev-lbl">Importo</label> <input id="imp-fndrsc-rev-lbl" disabled=""
														name="importo" type="text"
														[value]="fondoRischiRevisione.fondorischiControparti.length > 0 && !fondoRischiRevisione.importiTotali ? (sommaFondoRischiControparteAttr(fondoRischiRevisione, 'sorte') | euro) + ' &euro;' : 
														calcolaSomma([fondoRischiRevisione.importoFR, 0])">
												</p>
												<p class="col-sm-4">
													<label for="spese-leg-lbl">Spese legali</label> <input id="spese-leg-lbl" disabled=""
														name="interessi" type="text"
														[value]="fondoRischiRevisione.fondorischiControparti.length > 0 && !fondoRischiRevisione.importiTotali ? (sommaFondoRischiControparteAttr(fondoRischiRevisione, 'speseGiudizio') | euro) +' &euro;' : 
														calcolaSomma([fondoRischiRevisione.speseFR, 0])">
												</p>
												<p class="col-sm-4">
													<label for="interessi-lbl">Interessi</label> <input id="interessi-lbl" disabled=""
														name="compensi" type="text"
														[value]="fondoRischiRevisione.fondorischiControparti.length > 0 && !fondoRischiRevisione.importiTotali ? (sommaFondoRischiControparteAttr(fondoRischiRevisione, 'interessi') | euro) +' &euro;' : 
														calcolaSomma([fondoRischiRevisione.interesseFR, 0])">
												</p>
											</div>
										</div>	
											
									</fieldset>
								</div>
								<div class="row">
									<div class="bloccodati col-sm-12">
										<p class="col-sm-12">
											<label for="mot_revisione">Motivo aggiornamento</label> <input
												disabled="" name="mot_revisione" type="text"
												[value]="fondoRischiRevisione.motivoRevisione">
										</p>
									</div>
								</div>
	
				  <table class="table-striped table table-revisione-fondorischi">
					<caption class="sr-only">Tabella revisione fondo rischi</caption>
					<tr>
					  <th>Parte</th>
					  <!--<th>Società</th>-->
					  <th>Importo</th>
					  <th>Spese di giudizio</th>
					  <th>Interessi</th>
					  <!--<th>Rivalutazione</th>
					  <th>Previdenziali</th>
					  <th>Assistenziali</th>
					  <th>Tfr</th>-->
					</tr>
					<tr *ngFor="let fondorischioControparte of fondoRischiRevisione.fondorischiControparti">
					  <td>{{fondorischioControparte.controparte?.parte?.nominativo}}</td>
					  <!--<td>{{fondorischioControparte.controparte?.parte?.societa?.descrizione}}</td>-->
					  <td>{{fondorischioControparte.sorte | euro}} €</td>
					  <td>{{fondorischioControparte.speseGiudizio | euro}} €</td>
					  <td>{{fondorischioControparte.interessi | euro}} €</td>
					  <!--<td>{{fondorischioControparte.rivalutazione | euro}} €</td>
					  <td>{{fondorischioControparte.previdenziali | euro}} €</td>
					  <td>{{fondorischioControparte.assistenziali | euro}} €</td>
					  <td>{{fondorischioControparte.tfr | euro}} €</td>-->
					</tr>
				  </table>
	
							</li>
						</ul>
				</ul>
			</div>
		</div>
	</div>
</div>






<!-- <div class="modal-content">
	<p class="col-sm-2 col-sm-offset-10">
		<button class="btn btn-default-reverse btn-block btn-sm"
			data-dismiss="modal" type="button">Chiudi</button>
	</p>
	<div *ngIf="fondoRischiRevisioniList.length > 0" class="modal-dialog"
		role="document">
		<div class="col-sm-12 coldx">
			<h4>Revisioni dell fondo rischi</h4>
			<ul
				*ngFor="let fondoRischiRevisione of fondoRischiRevisioniList let i=index"
				id="controparticollapse" class="controparti">

				<li class="panel open_lighter">
					<div class="controparte">
						<div>
							<a data-toggle="collapse" href="#subcontroparti{{i}}"
								aria-expanded="false" aria-controls="'subcontroparti'+i"
								class="collapsed"><span>Apri</span></a>
							<h4 class="titolo col-sm-4">
								<a data-toggle="collapse" href="#subcontroparti{{i}}"
									aria-expanded="false" aria-controls="'subcontroparti'+i"
									class="collapsed"> Data inizio validit&agrave; {{
									fondoRischiRevisione.dataRevisioneDa | date:'dd/MM/yyyy'}}</a>
							</h4>
							<ng-template [ngIf]="!fondoRischiRevisione.gradoRischio">
								<p class="col-sm-4 matricola">
									Fondo rischi non attivo
								</p>
							</ng-template>
							<ng-template [ngIf]="fondoRischiRevisione.gradoRischio">
								<p class="col-sm-4 matricola">
									Grado di rischio: <strong>{{
										fondoRischiRevisione.gradoRischio?.label}}</strong>
								</p>
								<p class="col-sm-4 matricola">
									% di soccombenza: <strong>{{
										fondoRischiRevisione.percentualeSoccombenza ?
										fondoRischiRevisione.percentualeSoccombenza : 0 + ' %' }}</strong>
								</p>
							</ng-template>
						</div>
					</div>
					<ul class="subcontroparte collapse" id="subcontroparti{{i}}"
						aria-expanded="false" style="height: 40px;">
						<li>
							<div class="row_container_fieldset mtop20">
								<fieldset class="form-group">
									<legend>Revisione valori economici</legend>
									<div class="row">
										<div class="bloccodati col-sm-12">
											<p class="col-sm-6">
												<label for="importo">Importo</label> <input disabled=""
													name="importo" type="text"
													[value]="(fondoRischiRevisione.importoPetitum | euro) + ' &euro;'">
											</p>
											<p class="col-sm-6">
												<label for="interessi">Interessi</label> <input disabled=""
													name="interessi" type="text"
													[value]="(fondoRischiRevisione.interessiPetitum | euro) +' &euro;'">
											</p>
										</div>
										<div class="bloccodati col-sm-12">
											<p class="col-sm-4">
												<label for="compensi">Compensi</label> <input disabled=""
													name="compensi" type="text"
													[value]="(fondoRischiRevisione.compensi | euro) +' &euro;'">
											</p>
											<p class="col-sm-4">
												<label for="spese">Spese</label> <input disabled=""
													name="spese" type="text"
													[value]="(fondoRischiRevisione.spese | euro) +' &euro;'">
											</p>
											<p class="col-sm-4">
												<label for="altro">Altro</label> <input disabled=""
													name="spese" type="text"
													[value]="(fondoRischiRevisione.altro | euro) +' &euro;'">
											</p>
										</div>
									</div>
									<div class="row">
										<div class="bloccodati col-sm-12">
											<p class="col-sm-4">
												<label for="importo">Accantonamento importo</label> <input
													disabled="" name="importo" type="text"
													[value]="(fondoRischiRevisione.accantonamentoPetitum | euro) + ' &euro;'">
											</p>
											<p class="col-sm-4">
												<label for="interessi">Accantonamento interessi</label> <input
													disabled="" name="interessi" type="text"
													[value]="(fondoRischiRevisione.accantonamentoInteressi | euro) +' &euro;'">
											</p>
											<p class="col-sm-4">
												<label for="costi_gestione">Accantonamento Compensi e Spese Totali</label> <input disabled="" name="costi_gestione"
													type="text"
													[value]="(fondoRischiRevisione.accantonamentoCompensiSpeseTotale | euro) +' &euro;'">
											</p>
										</div>
									</div>
								</fieldset>
							</div>
							<div class="row">
								<div class="bloccodati col-sm-12">
									<p class="col-sm-12">
										<label for="mot_revisione">Motivo revisione</label> <input
											disabled="" name="mot_revisione" type="text"
											[value]="fondoRischiRevisione.motivoRevisione">
									</p>
								</div>
							</div>
						</li>
					</ul> 
			</ul>
		</div>
	</div>
</div> -->